// GradientButton.tsx
import { Button, ButtonProps } from 'react-bootstrap'
import styled from 'styled-components'

// Explicitly define the component with proper types
export const GradientButton = styled.button<ButtonProps>`
  background: linear-gradient(45deg, #402563, #114ee0);
  border: none;
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: white;
  &:hover:not(:disabled) {
    background: linear-gradient(45deg, #4c2d77, #1857e6);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    color: white;
  }
  &:disabled {
    background: linear-gradient(45deg, #402563, #114ee0);
    opacity: 0.5;
    color: white;
  }
`
